import type { PortfolioCollectionPlatform } from "@repo/shared/types";
import type { Localize } from "@/lib/i18n/use-localize";

/** A platform's label in the current language, falling back to its id when it has none or is gone. */
export function platformLabel(
  platforms: Pick<PortfolioCollectionPlatform, "id" | "labelI18n">[],
  platformId: string,
  localize: Localize,
): string {
  const platform = platforms.find((p) => p.id === platformId);
  return platform ? localize(platform.labelI18n) || platformId : platformId;
}
